@if (showMessage()) {
  @if (lastProcessInfo(); as lastProcessInfo) {
    @if (lastProcessInfo.process !== "GENERIC") {

      <app-process-info-window
        (messageClosed)="close()"
        [errorMessages]="errorMessages()"
        [process]="lastProcessInfo">
        @if (getPaper(lastProcessInfo.projectId, lastProcessInfo.paperId)) {
          <app-research-paper-card
            [disableAnimation]="true"
            [disablePapersDialog]="true"
            [hideAuthor]="true"
            [hideChips]="true"
            [paper]="getPaper(lastProcessInfo.projectId, lastProcessInfo.paperId)!">
          </app-research-paper-card>
        }
        <div class="process-message-box">
          <span>
            {{ lastProcessInfo.message }}
          </span>
        </div>
      </app-process-info-window>

    } @else {
      <div class="sse-container">
        <div class="sse-message">
          <div class="message-text">
            <p>{{ lastMessage() }}</p>
          </div>
          <button mat-icon-button class="close-btn" (click)="close()">
            <mat-icon>close</mat-icon>
          </button>
        </div>
      </div>
      @if (errorMessages(); as errorMessages) {

        @if (errorMessages.length > 0) {
          <div class="last-error-wrapper" [class.opened]="showErrors()">

            <div class="last-error-wrapper--btn">
              <button mat-icon-button class="show-error-btn"
                      (click)="showErrors.update(show => !show)"
                      matBadgePosition="before"
                      [matBadge]="errorMessages.length">
                <mat-icon>report</mat-icon>
              </button>
            </div>
            @if (showErrors()) {
              @for (errorMessage of errorMessages; track $index) {
                <div class="last-error">
                  <div class="message-text">
                    {{ errorMessage }}
                  </div>
                  <button mat-icon-button class="close-btn" (click)="removeError($index)">
                    <mat-icon>close</mat-icon>
                  </button>
                </div>
              }
            }
          </div>

        }
      }
    }
  }
}


@if (!isConnected() && isDevMode()) {
  <div class="sse-container">
    <div class="sse-message">
      <div class="message-text">
        <p>Not connected</p>
      </div>
    </div>
  </div>
}

